export default "__VITE_ASSET__C2C2mHf7__"